export interface BatchConfigRow {
    batchId: string;
    name: string;
    purpose: string;
    attachedConditions: string | number;
    status: string;
    detectionType: string;
    selectedEvent: selectedEvent;
    assetId: string;
    assetName: string;
    batchType: string;
}

export interface equipment {
    equipmentName: string;
    equipmentId: string;
}

export interface DeleteBatchConfigModalProps {
    handleClose: () => void;
    data: BatchConfigRow;
}

export interface BatchConfigDataType {
    currentPage: number;
    totalPages: number;
    batches: BatchConfigRow[];
}

export interface attachedCondition {
    status: string;
    event: string;
    action: string;
}

export interface BatchConfiguration {
  batchId?: string;
  name: string;
  purpose: string;
  batchType: string;
  selectedEquipments: equipment[];
  detectionType: string;
  batchFlow: { nodes: any[]; edges: any[] };
  selectedEvent: selectedEvent;
  startBatchAction: string;
  timeCycle?: any;
  assetId: string;
  chemicalUsage: string[];
  waterTreatment: {value: number | string, unit: string};
  trackingSensors: string[];
  attachedConditions: attachedCondition[];
}

export interface PreFormBatchConfiguration {
    batchTypes: { label: string; value: string }[];
    batchDetectionTypes: { label: string; value: string }[];
    timeCycleOptions: { label: string; value: string }[];
    waterTreatmentUnits: { label: string; value: string }[];
    batchStatusOptions: { label: string; value: string}[];
    batchActionOptions: { label: string; value: string }[];
}

export const PreFormBatchConfiguration = {
    name: '',
    purpose: '',
    batchType: '',
    detectionType: '',
    selectedEvent: {},
    trackingSensors: [],
    assetId: '',
    assetName: '',
    attachedConditions: [],
    status: '',
    startBatchAction: '',
};

export interface selectedEvent 
{   eventName: string;
    eventDescription: string;
    eventComponentId: string
}

export interface BatchConfigurationPayload {
  batchId?: string;
  name: string;
  purpose: string;
  batchType: string;
  detectionType: string;
  timeCycle: any;
  selectedEquipments: string[];
  batchFlow: { nodes: any[]; edges: any[] };
  selectedEvent: string;
  startBatchAction: string | undefined;
  assetId: string;
  chemicalUsage: string[];
  waterTreatment: {value: string | number, unit: string};
  trackingSensors: string[];
  attachedConditions: { status: string; event: string }[];
}

export interface BatchConfigurationFormProps {
    initialFormData: BatchConfiguration;
    preFormBatchConfiguration?: PreFormBatchConfiguration;
}

export interface initialBatchConfigurationFormState {
    name: string;
    purpose: string;
    batchType: string;
    detectionType: string;
    selectedEvent: selectedEvent
    assetId: string;
    assetName: string;
    attachedConditions: attachedCondition[];
    status: string;
    startBatchAction: string;
}

export const initialBatchConfigurationFormState: BatchConfiguration = {
  name: '',
  purpose: '',
  batchType: '',
  detectionType: '',
  selectedEvent: {eventName: '', eventDescription: '', eventComponentId: ''},
  selectedEquipments: [],
  batchFlow: { nodes: [], edges: [] },
  assetId: '',
  chemicalUsage: [],
  waterTreatment: { value: '', unit: '' },
  trackingSensors: [],
  attachedConditions: [],
  startBatchAction: '',
};